export class Blog {
  constructor() {
    const filterBtns = document.querySelectorAll('.tm-filter-button-group .btn-filter');

    filterBtns.forEach(btn => {
      if (btn.dataset.ajaxFilter) {
        btn.href = '/blog/category/' + btn.dataset.ajaxFilter.split(':')[1];
      }
      else {
        btn.href = '/blog/';
      }

      btn.addEventListener('click', e => {
        e.stopPropagation();
      });
    });
  }
}

export default new Blog;
